import { Flex, Spin } from "antd"

import AlertCard from "../AlertCard/AlertCard"

import "./AlertsList.less"

const AlertsList = ({
  data,
  handleSelectRow,
  handleChangeStatus,
  loading,
  emptyComponent,
  disabledStatus = false,
  isBulkActionActive = false,
  isRowSelected,
  onToggleRowSelection,
}) => {
  return (
    <Spin spinning={loading}>
      {data.length === 0 && (
        <Flex align="center" justify="center">
          {emptyComponent}
        </Flex>
      )}
      <div className="alerts-cards-list">
        {data.map((item) => (
          <AlertCard
            key={item.id}
            alert={item}
            handleSelectRow={handleSelectRow}
            handleChangeStatus={handleChangeStatus}
            disabledStatus={disabledStatus}
            isBulkActionActive={isBulkActionActive}
            selected={isBulkActionActive && isRowSelected?.(item.alert_id)}
            onToggleSelect={onToggleRowSelection}
          />
        ))}
      </div>
    </Spin>
  )
}

export default AlertsList
